<template>
    <router-link :to="route" :class="{ 'is-active': isActive, 'is-inline': inline }" @click="closeMenu">
        <slot />
    </router-link>
</template>

<script>
export default {
    name: 'MenuLink',

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        routeName: {
            type: String,
            required: true,
        },

        routeParams: {
            type: Object,
            required: false,
            default: () => ({}),
        },

        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        isActive() {
            return this.$route.name === this.routeName;
        },

        route() {
            return {
                name: this.routeName,
                params: this.routeParams,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.is-inline {
    display: inline;
}
</style>
